import React from 'react';
import { FormattedMessage } from 'react-intl';
import AuthFooter from 'components/Auth/AuthFooter';
import './CheckoutSuccessMeditationStudio.scss';

function Success() {
  return (
    <div className="Ms__Checkout__Success">
      <div className="Ms__Checkout__Success__FormCardWrap">
        <div className="Ms__Checkout__Success__ContentWrap">
          <div>
            <div className="Ms__Checkout__Success__Content">
              <center>
                <img className="Ms__Checkout__Success__CheckIcon" alt="check mark" src="/images/checkmark.png" />
                <div className="Ms__Checkout__Success__Heading">
                  <FormattedMessage id="views.checkoutSuccessMeditationStudio.success.heading" />
                </div>
                <div className="Ms__Checkout__Success__Body">
                  <div><FormattedMessage id="views.checkoutSuccessMeditationStudio.success.body" /></div>
                </div>
                <div className="Ms__Checkout__Success__Body__Store__Links">
                  <div className="Ms__Checkout__Success__Body__Store__Links__ImgWrap">
                    <a
                      href="https://apps.apple.com/us/app/meditation-studio-find-calm/id1066018502"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <img alt="apple store" src="/images/apple_store_black.png" />
                    </a>
                  </div>
                  <div className="Ms__Checkout__Success__Body__Store__Links__ImgWrap">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.meditationstudio&hl=en_CA"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <img alt="play store" src="/images/google_play_black.png" />
                    </a>
                  </div>
                </div>
              </center>
            </div>
          </div>
        </div>
        <div className="Ms__Checkout__Success__Footer">
          <AuthFooter />
        </div>
      </div>
    </div>
  );
}

export default Success;



// WEBPACK FOOTER //
// ./src/views/CheckoutSuccess/CheckoutSuccessMeditationStudio.jsx